import { render, staticRenderFns } from "./ThresholdTable.vue?vue&type=template&id=c614164e&"
import script from "./ThresholdTable.vue?vue&type=script&lang=ts&"
export * from "./ThresholdTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports